export default __webpack_public_path__ + "static/google-cloud-partner-272f76bdb3ce7f84742d24e10fc8de84.png";